import React, {useRef, useEffect, useState } from 'react';
import {IProps} from './types';
import * as S from './styles';
import C from '@assets/themes/colors';

const Tabs:React.FC<IProps> = (props) => {

  const tabWidth = props.sizes?.tabWidth ? props.sizes.tabWidth : 150;
  const barWidth = props.sizes?.barWidth ? props.sizes.barWidth : 100;
  const initLeftValue = (tabWidth - barWidth)/2;

  const [leftValue, setLeftValue] = useState(`${initLeftValue}px`);

  const handleSelectOption = (value: string, index: number) => {
    props.setValue(value);
    setLeftValue(`${initLeftValue + index*tabWidth}px`);
  }

  useEffect(() => {
    if (props.options.length===1) setLeftValue(`${initLeftValue}px`);
  }, [props.options])
  
  useEffect(() => {
    const valueIndex = props.options.findIndex(option => option === props.value);
    if (valueIndex >= 0) {
      setLeftValue(`${initLeftValue + valueIndex*tabWidth}px`);
    }
  }, [props.value])

  return (
    <S.Root style={props.containerStyle} >
      <S.TabsContainer>
        {
          props.options.map((option: string, index: number) => {
              return(
                <S.Tab
                  key={index}
                  onClick={() => handleSelectOption(option, index)}
                  textColor={option === props.value ? C.DARK_BLUE : C.MID_DARK_GRAY}
                  style={{
                    ...props.tabStyle,
                    width: `${tabWidth}px`,
                  }}
                >
                  {option}
                </S.Tab>
              )
            })
        }
      </S.TabsContainer>
      <S.IndicatorContainer>
        <S.Indicator
          style={{
            ...props.barStyle,
            width: `${barWidth}px`,
          }}
          leftValue={leftValue}
        />
      </S.IndicatorContainer>
    </S.Root>
  );
}

export default Tabs;